// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import ElementUI, { Message } from 'element-ui'
import store from '@/store'
import 'element-ui/lib/theme-chalk/index.css'
import Vuetify from 'vuetify/dist/vuetify'
import 'vuetify/dist/vuetify.min.css'
import htmlToPdf from './utils/htmlToPdf'
import './assets/icon/iconfont.css'

// 中英文翻译
import i18n from './lang/i18n'

// 公共样式
import './assets/scss/reset.css'
import './assets/scss/index.css'
import './assets/scss/icon.css'
// svg图标
import '@/icons'
// 引入公共js
import './assets/js/Common.js'
import CommonUtil from './assets/js/CommonUtil.js'
import NewCommonUtil from './assets/js/NewCommonUtil'
import FinalData from './assets/js/FinalData.js'
Vue.prototype.$finalData = FinalData
Vue.prototype.$commonUtil = CommonUtil
Vue.prototype.$common = NewCommonUtil

// 组件
import b2b_button from './pages/newPages/components/B2B_button';
Vue.component('b2b-button', b2b_button)

Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(Vuetify)
Vue.use(htmlToPdf)

Vue.config.productionTip = false

// http 请求拦截
Vue.http.interceptors.push((request, next) => {
  // 请求拦截
  let lateTime = 6 * 3600 * 1000
  let newLoginTime = new Date().getTime()
  let lastLoginTime = localStorage.getItem('lastLoginTime')
  let differ = newLoginTime - lastLoginTime
  if (lastLoginTime > 0) {
    if (differ > lateTime) {
      store.commit('delUser')
      router.go(0)
    } else {
      localStorage.setItem('lastLoginTime', newLoginTime)
    }
  }
  // 请求拦截
  next((response) => {
    // 响应拦截
    // 响应拦截
    if (response.body.code === 6 && !router.currentRoute.path.includes('view/index')) {
      store.commit('delUser')
      router.push('/login')
      return Message.warning(response.body.message);
    }
    return response
  })
})

router.beforeEach((to, from, next) => {
  let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'

  if (from.fullPath == '/') {
    if (document.domain == 'www.zoodian.com' && to.fullPath == '/view/index/aboutUs') {
      return next('/NewHome/HomeSearch')
    }
  }

  if (to.fullPath.includes('/view/index/')) {
    document.title = '科坦科技 - 商旅酒店供应链技术服务商'
    link.href = 'data:image/png;base64,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'
  } else {
    document.title = '筑店 - 科坦旗下酒店智能预订服务平台'
    link.href = '../static/img/b2b-icon.png?v=1.2'
  }

  next();
})

/* eslint-disable no-new */
const thisVue = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default thisVue



// WEBPACK FOOTER //
// ./src/main.js